<template>
    <listings-messages-store
        :params="{
            listing: listing.uuid
        }"
        v-slot="{
            sid,
            is_loading: is_saving,
            has_loaded: has_saved,
            store
        }"
        @success="onListingsMessagesStore"
    >
        <base-form @submit="store(form)">
            <form-item
                :sid="sid"
                :is-required="true"
                name="email"
            >
                <template slot="label">Email</template>

                <input-text
                    v-model="form.email"
                    :sid="sid"
                    :disabled="is_saving || has_saved"
                    name="email"
                    type="email"
                />

                <template slot="hint">
                    Have an account?
                    <laroute-link
                        :to="{
                            name: 'auth.sessions.create',
                            params: {
                                intended: $route.fullPath
                            }
                        }"
                        class="text-blue"
                    >
                        Login first
                    </laroute-link>
                </template>
            </form-item>

            <form-item
                :sid="sid"
                :is-required="true"
                name="text"
            >
                <template slot="label">Message</template>

                <input-textarea
                    v-model="form.text"
                    :sid="sid"
                    :disabled="is_saving || has_saved"
                    :rows="5"
                    name="text"
                    :placeholder="placeholder"
                />
            </form-item>

            <base-button
                :is-loading="is_saving || has_saved"
                class="w-full btn-blue"
            >
                Send Message
            </base-button>
        </base-form>
    </listings-messages-store>
</template>

<script>
    import local from '../../../../store/local'
    import ListingsMessagesStore from '../../../../components/listings-messages-store'

    export default {
        components: {
            ListingsMessagesStore
        },
        props: {
            listing: {
                type: Object,
                required: true
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                form: {
                    email: '',
                    text: ''
                }
            }
        },
        watch: {
            'form.email' () {
                local.set('guest-email', this.form.email)
            },
            'form.text' () {
                local.set(`message-by-listing:${this.listing.uuid}`, this.form.text)
            }
        },
        created () {
            if (!this.form.email) {
                this.form.email = local.get('guest-email')
            }

            if (!this.form.text) {
                this.form.text = local.get(`message-by-listing:${this.listing.uuid}`)
            }
        },
        methods: {
            onListingsMessagesStore ({ data: message }) {
                window.location = this.$laroute.route('auth.users.create', {
                    profile: 'tenant',
                    intention: 'listing-message',
                    intended: this.$laroute.route('listings.messages.send.create', {
                        listing: this.listing.uuid,
                        message: message.uuid
                    })
                })
            }
        }
    }
</script>
